import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.transactions.title',
    defaultMessage: 'Transactions',
    description: 'title of the transactions page',
  },
  create: {
    button: {
      id: 'pages.transactions.create.button',
      defaultMessage: 'Create',
      description: 'title of the create transaction button',
    },
  },
  paymentLinkDialog: {
    title: {
      id: 'pages.transactions.paymentLinkDialog.title',
      defaultMessage: 'Payment link',
      description: 'title of the transactions payment link dialog',
    },
    fields: {
      paymentLinkUrl: {
        tooltip: {
          id: 'pages.transactions.paymentLinkDialog.fields.paymentLinkUrl.tooltip',
          defaultMessage: 'Payment link copied',
          description: 'label of the copied payment link tooltip',
        },
        button: {
          id: 'pages.transactions.paymentLinkDialog.fields.paymentLinkUrl.button',
          defaultMessage: 'Copy payment link',
          description: 'label of the copy payment link button',
        },
      },
    },
    actions: {
      close: {
        id: 'actions.close',
        defaultMessage: 'Close',
        description: 'label of the close payment link dialog button',
      },
    },
  },
  transactionCard: {
    properties: {
      total: {
        label: {
          id: 'properties.total',
          defaultMessage: 'total',
          description: 'label of the total property',
        },
      },
      paid: {
        label: {
          id: 'properties.paid',
          defaultMessage: 'Paid',
          description: 'label of the paid property',
        },
      },
    },
    status: {
      paid: {
        id: 'properties.paid',
        defaultMessage: 'Paid',
        description: 'label of the paid status',
      },
      unpaid: {
        id: 'properties.unpaid',
        defaultMessage: 'Unpaid',
        description: 'label of the unpaid status',
      },
    },
  },
};

export default defineMessages(translations);
